import { Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/cn';
import { Icon } from '@/ui/common';

export interface CasinoHeaderRowProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  /** Debounced value after idle (default 1s), only when length > 2 or cleared. */
  onSearchCommit?: (value: string) => void;
  providersActive?: boolean;
  className?: string;
}

export function CasinoHeaderRow({
  searchValue = '',
  onSearchChange,
  onSearchCommit,
  providersActive = false,
  className,
}: CasinoHeaderRowProps) {
  const [local, setLocal] = useState(searchValue);
  // Remount via parent `key` when the committed URL search changes; keep typing local.

  useEffect(() => {
    if (!onSearchCommit) return;
    const handle = window.setTimeout(() => {
      const trimmed = local.trim();
      if (trimmed.length === 0 || trimmed.length > 2) onSearchCommit(trimmed);
    }, 1000);
    return () => window.clearTimeout(handle);
  }, [local, onSearchCommit]);

  return (
    <div className={cn('flex items-center gap-4', className)}>
      <label className="flex h-11 min-w-0 flex-1 items-center gap-2.5 rounded-md border border-border-default bg-bg-surface px-4 py-3">
        <Icon name="search" size={16} className="shrink-0 text-text-secondary" />
        <input
          type="search"
          value={local}
          onChange={(event) => {
            const next = event.target.value;
            setLocal(next);
            onSearchChange?.(next);
          }}
          placeholder="Search games"
          className="min-w-0 flex-1 bg-transparent text-body-s text-text-primary outline-none placeholder:text-text-secondary"
          autoComplete="off"
        />
      </label>
      <Link
        to="/casino/providers"
        className={cn(
          'inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-md border border-border-default bg-bg-surface px-4 py-3 text-label-s text-text-primary',
          providersActive && 'border-action-primary text-action-primary',
        )}
      >
        <Icon name="filters" size={16} />
        Providers
      </Link>
    </div>
  );
}
